import { useState, type ReactNode } from "react";

export interface ProductTab {
  id: string;
  label: string;
  content: ReactNode;
}

/**
 * Porté à l'identique depuis apps/web/components/product/ProductTabs.tsx
 * (aucune dépendance Next.js dans l'original).
 */
export function ProductTabs({ tabs }: { tabs: ProductTab[] }) {
  const [activeId, setActiveId] = useState<string | undefined>(tabs[0]?.id);

  if (tabs.length === 0) return null;

  return (
    <div>
      <div className="hidden md:block">
        <div className="flex gap-6 overflow-x-auto border-b border-line" role="tablist">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              type="button"
              role="tab"
              aria-selected={activeId === tab.id}
              onClick={() => setActiveId(tab.id)}
              className={[
                "whitespace-nowrap border-b-2 px-1 py-3 font-body text-sm font-medium",
                activeId === tab.id ? "border-gold text-navy" : "border-transparent text-muted hover:text-navy",
              ].join(" ")}
            >
              {tab.label}
            </button>
          ))}
        </div>
        <div className="py-6">{tabs.find((tab) => tab.id === activeId)?.content}</div>
      </div>

      <div className="space-y-1 md:hidden">
        {tabs.map((tab, i) => (
          <details key={tab.id} open={i === 0} className="border-b border-line py-2">
            <summary className="cursor-pointer font-body text-sm font-medium text-navy">{tab.label}</summary>
            <div className="pt-3">{tab.content}</div>
          </details>
        ))}
      </div>
    </div>
  );
}
